import React, { useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { Upload, Loader2, X } from "lucide-react";
import { toast } from "sonner";

export function ImageUpload({ value, onChange, testid = "image-upload", label = "Upload", round = false, accept = "image/*" }) {
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const res = await api.post("/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(res.data.url);
      toast.success("Uploaded");
    } catch (err) {
      toast.error("Upload failed");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="flex items-center gap-3">
      <div
        className={`relative flex items-center justify-center overflow-hidden border-2 border-dashed border-zinc-300 bg-zinc-50 ${
          round ? "h-20 w-20 rounded-full" : "h-24 w-24 rounded-xl"
        }`}
      >
        {value ? (
          <>
            <img src={fileUrl(value)} alt="preview" className="h-full w-full object-cover" />
            <button
              type="button"
              data-testid={`${testid}-remove`}
              onClick={() => onChange("")}
              className="absolute right-1 top-1 rounded-full bg-black/60 p-0.5 text-white"
            >
              <X className="h-3 w-3" />
            </button>
          </>
        ) : uploading ? (
          <Loader2 className="h-5 w-5 animate-spin text-emerald-600" />
        ) : (
          <Upload className="h-5 w-5 text-zinc-400" />
        )}
      </div>
      <label className="cursor-pointer rounded-full border border-zinc-300 bg-white px-4 py-2 text-sm font-medium text-zinc-700 transition-colors hover:bg-zinc-50">
        {uploading ? "Uploading…" : label}
        <input type="file" accept={accept} className="hidden" data-testid={testid} onChange={handleFile} disabled={uploading} />
      </label>
    </div>
  );
}
